import formatMoney from '../../core/formatMoney';

export default (product) => {
  const CONSTANTS = {
    MONEY_FORMAT: theme.moneyFormat,
    DEFAULT_ALT_TEXT: {
      FRONT: 'Front of',
      BACK: 'Back of',
      WITH_COLOR: 'with color',
    }
  };

  // Determine price display
  let priceHtml = '';
  let product_from = '';
  if (product.raw_price_max > product.raw_price_min) {
    product_from = product.price_min;
  }

  if (product_from === '') {
    if (product.raw_compare_at_price > product.raw_price) {
      priceHtml = `
        <span class="visually-hidden">Regular price</span>
        <s class="price__compare-at">${formatMoney(Number(product.compare_at_price).toFixed(2), CONSTANTS.MONEY_FORMAT)}</s>
        <span class="price__sales">${formatMoney(Number(product.price).toFixed(2), CONSTANTS.MONEY_FORMAT)}</span>
      `;
    } else {
      priceHtml = `<span class="price__regular">${formatMoney(Number(product.price).toFixed(2), CONSTANTS.MONEY_FORMAT)}</span>`;
    }
  } else {
    priceHtml = `<span class="price__regular">From ${formatMoney(Number(product_from).toFixed(2), CONSTANTS.MONEY_FORMAT)}</span>`;
  }

  return `
    <div class="recently-viewed-products-item swiper-slide">
      <a href="${window.Shopify.routes.root}products/${product.handle}">
        <div class="recently-viewed-products__image">
          <img loading="lazy" alt="${product.title}" src="${product.featured_image.replace('.jpg', '_220x340@2x.jpg')}" onError="this.onerror=null; this.src='${window.theme.collections.placeholder}';" />
          <div class="recently-viewed-products__shop">SHOP NOW</div>
        </div>
        <p class="recently-viewed-products__name">${product.title}</p>
        <p class="recently-viewed-products__price">${priceHtml}</p>
      </a>
    </div>
  `;
};
